import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import ViSourceData from './vi-source-data'
import ViDestinationItems from './vi-destination-items'
import ViMapping from './vi-mapping'

let views = [
	ViSourceData,
	ViDestinationItems,
	ViMapping
]

const MappingsWizard = Wizard.extend({

	/**
	 * Wizard for modifying the mappings of an import
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Import} options.model
	 */
	initialize: function(options = {}) {
		this.options = options
		this.options.doneKey = 'common.save'
		let opts = _.extend({
			views
		}, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	finish: function () {
		this.trigger('done')
	}

})

export default MappingsWizard

MappingsWizard.__filename__ = 'imports/vi/mappings-wizard.js'
